import { Fragment, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";

const LOGO = "/assets/logo.png";

const LINKS = [
  { id: "services", label: "Services" },
  { id: "featured",  label: "Featured Work" },
  { id: "packages",  label: "Packages" },
  { id: "websites",  label: "Websites" },
  { id: "monthly",   label: "Monthly Social" },
  { id: "grants",    label: "Grants" },
  { id: "faq",       label: "FAQ" },
  { id: "contact",   label: "Contact" },
];

export default function Header() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setOpen(false), [pathname]);

  const go = (id) => {
    setOpen(false);
    if (pathname !== "/") { navigate("/"); setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 150); }
    else document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header data-testid="site-header" className={`fixed top-0 inset-x-0 z-50 transition-all ${scrolled ? "bg-[#171210]/95 shadow-lg shadow-black/30" : "bg-[#171210]"} border-b border-copper/15`}>
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 flex items-center justify-between h-20 md:h-24 gap-4">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3 shrink-0">
          <img src={LOGO} alt="Toliver Signature Services" className="h-12 w-12 md:h-14 md:w-14 object-cover rounded-full ring-1 ring-copper/40" />
          <div className="leading-none">
            <p className="font-serif font-medium text-white text-lg md:text-xl tracking-[0.18em]">TOLIVER</p>
            <p className="text-copper-300 text-[9px] md:text-[10px] uppercase tracking-[0.32em] mt-1">Signature Services</p>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-4 xl:gap-5">
          {LINKS.map((l) => (
            <Fragment key={l.id}>
              <button onClick={() => go(l.id)} data-testid={`nav-${l.id}`} className="text-[11px] font-semibold uppercase tracking-[0.18em] text-white/80 hover:text-copper-300 transition-colors">
                {l.label}
              </button>
              {l.id === "services" && (
                <Link to="/business-assistance" data-testid="nav-business-assistance" className="text-[11px] font-semibold uppercase tracking-[0.18em] text-white/80 hover:text-copper-300 transition-colors whitespace-nowrap">
                  Assistance
                </Link>
              )}
            </Fragment>
          ))}
          <Link to="/start-your-project" data-testid="nav-start-project" className="text-[11px] font-semibold uppercase tracking-[0.18em] text-copper-300 hover:text-copper-200 transition-colors whitespace-nowrap">
            Start Your Project
          </Link>
        </nav>

        <button onClick={() => go("contact")} data-testid="header-cta" className="btn-copper header-cta-btn !py-3 !px-6">
          GET A FREE QUOTE <ArrowRight size={14} />
        </button>
        <button data-testid="header-mobile-toggle" onClick={() => setOpen((v) => !v)} className="lg:hidden text-white p-2" aria-label="menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div data-testid="header-mobile-menu" className="lg:hidden bg-[#171210] border-t border-copper/15 px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <Fragment key={l.id}>
              <button onClick={() => go(l.id)} className="text-left text-sm uppercase tracking-[0.22em] font-semibold text-white/85 hover:text-copper-300">{l.label}</button>
              {l.id === "services" && (
                <Link to="/business-assistance" data-testid="nav-business-assistance-mobile" className="text-left text-sm uppercase tracking-[0.22em] font-semibold text-white/85 hover:text-copper-300">Assistance</Link>
              )}
            </Fragment>
          ))}
          <Link to="/start-your-project" data-testid="nav-start-project-mobile" className="text-left text-sm uppercase tracking-[0.22em] font-semibold text-copper-300 hover:text-copper-200">Start Your Project</Link>
          <button onClick={() => go("contact")} className="btn-copper self-start mt-2">GET A FREE QUOTE <ArrowRight size={14} /></button>
        </div>
      )}
    </header>
  );
}
